<em class="fas fa-tag fa-fw" [style.color]="tagColor()"></em>
<div class="tag-name text-ellipsis" [matTooltip]="tagName()">
  {{ tagName() }}
</div>
